import { DEFAULT_ZONE_SLUG } from 'consts'
import { ComponentType } from 'react'
import { Container } from 'reactstrap'
import styled from 'styled-components'
import { RoleModel } from 'utils/role'
import { LinkCard } from 'views/common/link-card'

const Wrapper = styled.div`
  padding-bottom: 32px;
`

const LinkCardWrapper = styled.div`
  padding-bottom: 30px;
`

interface Props {
  categories: any[]
  role: RoleModel
}

export const CategoriesDesktop: ComponentType<Props> = ({ categories, role }) => (
  <Wrapper>
    <Container>
      <div className="five-row">
        {categories.map((category) => (
          <LinkCardWrapper key={category.uuid} className="five-col-1">
            <LinkCard
              href="/[categorySlug]/[roleSlug]/[zoneSlug]"
              as={`/${category.slug}/${role.slug}/${DEFAULT_ZONE_SLUG}`}
              title={category.pluralName}
              text={`Ver ${category.properties} ${category.pluralName}`}
              image={category.cover?.thumbnailUrl}
            />
          </LinkCardWrapper>
        ))}
      </div>
    </Container>
  </Wrapper>
)
